import { Registry, withRegistry } from '@bem-react/di';
import { hot } from 'react-hot-loader/root';

import AppCommon from 'client/common/components/app';

import { createInitializer } from 'client/platforms/init';

import Footer from './components/footer';
import Header from './components/header';
import Level from './components/level';
import MainLayout from './components/main-layout';
import MainMenu from './components/main-menu';
import Media from './components/media';
import PageTitle from './components/page-title';
import Prefooter from './components/prefooter';
import Search from './components/search';
import Sidebar from './components/sidebar';
import SidebarDimmer from './components/sidebar-dimmer';
import SidebarPusher from './components/sidebar-pusher';
import VideoIframe from './components/video-iframe';
import YaShare from './components/ya-share';
import SolutionPage from './pages/solution';
import SolutionsPage from './pages/solutions';

import { legoRegistry } from './components/lego/registry';

const registry = new Registry({ id: 'app' });

registry
    .set('Header', Header)
    .set('Footer', Footer)
    .set('Prefooter', Prefooter)
    .set('MainMenu', MainMenu)
    .set('MainLayout', MainLayout)
    .set('Sidebar', Sidebar)
    .set('SidebarPusher', SidebarPusher)
    .set('SidebarDimmer', SidebarDimmer)
    .set('PageTitle', PageTitle)
    .set('Search', Search)
    .set('SolutionPage', SolutionPage)
    .set('Level', Level)
    .set('YaShare', YaShare)
    .set('Media', Media)
    .set('SolutionsPage', SolutionsPage)
    .set('VideoIframe', VideoIframe);

export const App = hot(
    withRegistry(registry, legoRegistry)(AppCommon)
);
export const init = createInitializer(App);
